/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * Top-level order status for member's lab order journey
 */
export type TopLevelOrderStatus = typeof TopLevelOrderStatus[keyof typeof TopLevelOrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TopLevelOrderStatus = {
  eligible: 'eligible',
  ready_for_testing: 'ready_for_testing',
  pending_review: 'pending_review',
  results_ready: 'results_ready',
} as const;
